import * as Common from '@piccolohealth/pbs-common';
import { ChakraV3, Spin, useRequiredParams } from '@piccolohealth/ui';
import React from 'react';
import { GridItemContainer } from '../../components/generic/GridItemContainer';
import { PiccoloError } from '../../components/generic/PiccoloError';
import { ContentLayout } from '../../components/layouts/ContentLayout';
import { useIncidentQuery } from '../../graphql/hooks/useIncidentQuery';
import { useAppContext } from '../../hooks/useAppContext';
import { IncidentActionMenu } from './IncidentActionMenu';
import { IncidentCard } from './IncidentDetailsCard';
import { IncidentFilesCard } from './IncidentFilesCard';
import { IncidentTeamCard } from './IncidentTeamCard';
import { IncidentUpdateStatusControl } from './IncidentUpdateStatusControl';

export const Incident = () => {
  const { incidentId } = useRequiredParams<{ incidentId: string }>();

  const { organization } = useAppContext();

  const { data, error, isLoading } = useIncidentQuery({
    organizationId: organization.id,
    incidentId,
  });

  const incident = data?.organization?.incident as Common.Incident | undefined;

  if (isLoading) {
    return <Spin />;
  }

  if (error) {
    return <PiccoloError error={error} />;
  }

  if (!incident) {
    return (
      <PiccoloError
        error={
          new Common.PiccoloError({
            type: 'IncidentNotFound',
            message: 'Incident not found',
          })
        }
      />
    );
  }

  return (
    <ContentLayout
      headerContent={
        <ChakraV3.HStack align='start'>
          <ChakraV3.Heading size='3xl' fontWeight='bold'>
            {Common.renderIncidentShortId(incident.shortId)}
          </ChakraV3.Heading>
          <ChakraV3.Spacer />
          <IncidentUpdateStatusControl incident={incident} />
          <IncidentActionMenu incident={incident} />
        </ChakraV3.HStack>
      }
    >
      <ChakraV3.SimpleGrid
        px={6}
        columns={{
          xl: 1,
          '2xl': 2,
        }}
        gap={4}
      >
        <GridItemContainer>
          <ChakraV3.Stack gap={4}>
            <IncidentCard incident={incident} />
          </ChakraV3.Stack>
        </GridItemContainer>
        <GridItemContainer>
          <ChakraV3.Stack gap={4}>
            <IncidentTeamCard incident={incident} />
            <IncidentFilesCard incidentId={incidentId} />
          </ChakraV3.Stack>
        </GridItemContainer>
      </ChakraV3.SimpleGrid>
      <ChakraV3.Separator />
    </ContentLayout>
  );
};
